import { createApp, h } from 'vue'
import Login from './AppLogin.vue'
import LoginCn from './AppLoginCn.vue'
import LoginEdu from '@/views/AppEduPages/components/LoginEdu/Login.vue'
import i18n from '@/i18n'
import getDomains from '@common/utils/getDomains'
import { eventBus } from '@common/utils/eventBus'
import trackEvent from '@common/track/trackEvent'

interface LoginOptions {
  type: 'login' | 'register' | 'loginCn' | 'loginEdu'
  canClose?: boolean
  cancel?: () => void
  onSuccess?: (data: any) => void
}
const _env_ = window._ENV_ || 'CN'
const isEdu = getDomains().thirdLevelDomain === 'edu'

export type LoginServiceType = (options: LoginOptions) => void

let appInstance: any = null
let app: ReturnType<typeof createApp> | null = null
const destroyApp = () => {
  // 从 DOM 中移除实例
  app?.unmount()
  appInstance = null

  // 移除临时的 div
  const div = document.querySelector('#app-login')
  if (div) {
    document.body.removeChild(div)
  }
}
const LoginService = (options: LoginOptions) => {
  trackEvent.track('login_show')
  options.canClose = options.canClose ?? true
  // 如果已存在实例，先销毁
  if (appInstance) {
    destroyApp()
  }

  app = createApp({
    render() {
      return h(isEdu ? LoginEdu : _env_ === 'CN' ? LoginCn : Login, {
        ...options,
        onClose: () => {
          if (!options.canClose) return
          destroyApp()
          options.cancel?.()
        },
        onOk: (data: any) => {
          window.isLoggedIn = true
          // 确保回调在组件销毁后执行
          setTimeout(() => {
            options.onSuccess?.(data)
          }, 0)
          destroyApp()
        }
      })
    }
  })
  // 如果是教育版登录，立即触发显示事件
  if (isEdu) {
    setTimeout(() => {
      eventBus.trigger('showLogin')
    }, 0)
  }

  const div = document.createElement('div')
  div.id = 'app-login'
  document.body.appendChild(div)
  appInstance = app.use(i18n).mount(div)
}

export default LoginService
